import { createAppStore } from '@app/core/stores';

interface UserSettingsState {
  timezone: string | null;
  /** User-selected locale (e.g. 'es-AR'). Persisted; used by locale resolution. */
  locale: string | null;
  /** Sets the app locale and persists it. Triggers reload when needed via locale helper. */
  setLocale: (locale: string) => void;
}

export function useSetLocale() {
  return useUserSettingsStore((s) => s.setLocale);
}

/**
 * Zustand store for managing user settings.
 * Replaces the Redux implementation with a simpler Zustand store.
 */
export const useUserSettingsStore = createAppStore<UserSettingsState>('UserSettingsStore', {
  persist: { name: 'app.userSettings', version: 1 },
})((set) => ({
  // Initial state
  timezone: null,
  locale: null,

  setLocale: (locale) => {
    set({ locale });
  },
}));
